<template>
    <div class="login-page">
        <el-button class="login-back" link @click="back">
            <el-icon>
                <ArrowLeft />
            </el-icon>
            <span>返回</span>
        </el-button>

        <div class="login-card">
            <!-- 品牌区：桌面端位于左侧，移动端收为顶部条 -->
            <aside class="login-brand">
                <img class="login-brand__logo" alt="hidoc" :src="mascotImage" />
                <h1 class="login-brand__name">hidoc</h1>
                <p class="login-brand__slogan">知识沉淀 · 协作共享</p>
            </aside>

            <!-- 表单区 -->
            <section class="login-panel">
                <header class="login-panel__head">
                    <h2 class="login-panel__title">欢迎回来</h2>
                    <p class="login-panel__subtitle">登录以继续使用 hidoc</p>
                </header>

                <el-tabs v-model="activeName" class="login-tabs" stretch>
                    <el-tab-pane label="密码登录" name="first">
                        <el-form ref="loginForm" :model="form" :rules="rules" status-icon label-position="top"
                            class="login-form" @submit.prevent>
                            <el-form-item label="邮箱" prop="username">
                                <el-input id="username" v-model="form.username" size="large" maxlength="64"
                                    placeholder="请输入邮箱或账号">
                                    <template #prefix>
                                        <el-icon>
                                            <Message />
                                        </el-icon>
                                    </template>
                                </el-input>
                            </el-form-item>
                            <el-form-item label="密码" prop="password">
                                <el-input id="password" v-model="form.password" type="password" size="large"
                                    maxlength="64" autocomplete="off" show-password placeholder="请输入您的密码"
                                    @keyup.enter="onSubmit()" @focus="passwordFocused = true"
                                    @blur="passwordFocused = false">
                                    <template #prefix>
                                        <el-icon>
                                            <Lock />
                                        </el-icon>
                                    </template>
                                </el-input>
                            </el-form-item>
                            <el-button class="login-submit" type="primary" size="large" @click="onSubmit()">{{
                                $t('login') }}</el-button>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="验证码登录" name="second">
                        <el-form ref="codeLoginForm" :model="form" :rules="rules" status-icon label-position="top"
                            class="login-form" @submit.prevent>
                            <el-form-item label="邮箱" prop="username">
                                <el-input id="usernameCode" v-model="form.username" size="large" maxlength="64"
                                    placeholder="请输入注册邮箱">
                                    <template #prefix>
                                        <el-icon>
                                            <Message />
                                        </el-icon>
                                    </template>
                                </el-input>
                            </el-form-item>
                            <el-form-item label="验证码" prop="authCode">
                                <div class="login-form__row">
                                    <el-input id="authCode" v-model="form.authCode" size="large" maxlength="6"
                                        autocomplete="off" placeholder="请输入邮箱验证码" @keyup.enter="onSubmit()"></el-input>
                                    <el-button size="large" :disabled="codeCountdown > 0"
                                        @click="getAuthCodeForLogin">{{
                                        codeCountdown > 0 ? codeCountdown + 's 后重发' : '获取验证码' }}</el-button>
                                </div>
                            </el-form-item>
                            <el-button class="login-submit" type="primary" size="large" @click="onSubmit()">登 录</el-button>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="动态口令登录" name="third">
                        <el-form :model="form" :rules="rules" status-icon label-position="top" class="login-form"
                            @submit.prevent>
                            <el-form-item label="邮箱" prop="username">
                                <el-input id="usernameTotp" v-model="form.username" size="large" maxlength="64"
                                    placeholder="请输入注册邮箱">
                                    <template #prefix>
                                        <el-icon>
                                            <Message />
                                        </el-icon>
                                    </template>
                                </el-input>
                            </el-form-item>
                            <el-form-item label="动态口令">
                                <verification-code v-model="form.totpcode" @complete="onTotpComplete" />
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                </el-tabs>

                <footer class="login-panel__foot">
                    <el-link :underline="false" @click="openResetPasswordDialog">忘记密码</el-link>
                    <span class="login-panel__sep"></span>
                    <el-link :underline="false" @click="register">注册账号</el-link>
                </footer>
            </section>
        </div>

        <!-- 重置密码弹框 -->
        <el-dialog class="login-reset-dialog" title="重置密码" width="440" align-center
            v-model="resetPasswordDialogVisible">
            <template #header>
                <div class="reset-dialog__head">
                    <h3 class="reset-dialog__title">重置密码</h3>
                    <p class="reset-dialog__subtitle">验证注册邮箱后设置新密码</p>
                </div>
            </template>
            <el-form :model="resetPasswordForm" label-position="top" class="reset-form">
                <el-form-item label="邮箱" prop="email">
                    <el-input v-model="resetPasswordForm.email" maxlength="64" placeholder="请输入您的注册邮箱"></el-input>
                </el-form-item>
                <el-form-item label="验证码" prop="authCode">
                    <div class="reset-form__row">
                        <el-input id="authCode" v-model="resetPasswordForm.authCode" maxlength="64"
                            placeholder="请填写发送到您邮箱的验证码"></el-input>
                        <el-button @click="getAuthCodeForResetPassword">获取验证码</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="新的密码">
                    <el-input id="password" v-model="resetPasswordForm.password" placeholder="请输入新密码"
                        show-password></el-input>
                </el-form-item>
                <el-form-item label="确认新密码">
                    <el-input v-model="resetPasswordForm.passwordConfirm" placeholder="请再次输入新密码"
                        show-password></el-input>
                </el-form-item>
            </el-form>
            <template #footer>
                <div class="reset-dialog__foot">
                    <el-button @click="resetPasswordDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="resetPassword">确 定</el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import { ref, watch } from 'vue';
import request from '../../utils/request.js';
import { ElMessageBox, ElMessage } from 'element-plus';
import { Message, Lock, ArrowLeft } from '@element-plus/icons-vue';
import VerificationCode from '../../components/VerificationCode.vue';

// 记录上次使用的登录方式（页签），下次进入登录页自动切回
const LOGIN_TAB_KEY = 'hidoc_login_active_tab';
const LOGIN_TABS = ['first', 'second', 'third'];

const readLoginTab = () => {
    const saved = localStorage.getItem(LOGIN_TAB_KEY);
    return LOGIN_TABS.includes(saved) ? saved : 'first';
};

export default {
    data() {
        return {
            activeName: readLoginTab(),
            passwordFocused: false,
            resetPasswordDialogVisible: false,
            // 获取验证码倒计时
            codeCountdown: 0,
            codeTimer: null,
            form: {
                username: '',
                password: '',
                totpcode: '',
                authCode: '',
                uid: ''
            },
            rules: {
                username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
                authCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
                // password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
            },
            resetPasswordForm: {
                username: '',
                email: '',
                authCode: '',
                uid: '',
                password: '',
                passwordConfirm: ''
            }
        };
    },
    components: { VerificationCode, Message, Lock, ArrowLeft },
    setup() { },
    computed: {
        // 密码框聚焦时用戴墨镜形态，未聚焦时用墨镜架在头上的形态
        mascotImage() {
            return this.passwordFocused ? require('../../assets/mascot/kip_sunglasses.png') : require('../../assets/mascot/kip_sunglasses_head.png');
        }
    },
    watch: {
        // 切换页签时记住当前登录方式
        activeName(value) {
            localStorage.setItem(LOGIN_TAB_KEY, value);
        }
    },
    mounted() {
        document.title = '登录';
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.handleResize);
        this.stopCountdown();
    },
    methods: {
        handleResize(event) {
            this.fullWidth = document.documentElement.clientWidth;
        },
        home() {
            this.$router.push({ path: '/', params: {} });
        },
        back() {
            this.$router.go(-1); //返回上一层
            // this.$router.push({ path: '/' });
        },
        register() {
            this.$router.push({ path: '/register', params: {} });
        },
        onSubmit() {
            // 邮箱验证码登录：不走表单校验，按验证码规则自行检查
            if (this.activeName === 'second') {
                if (!this.form.username) {
                    ElMessage({ message: '请输入邮箱', type: 'warning', duration: 3 * 1000 });
                    return;
                }
                if (!this.form.uid) {
                    ElMessage({ message: '请先获取验证码', type: 'warning', duration: 3 * 1000 });
                    return;
                }
                if (!this.form.authCode || this.form.authCode.length !== 6) {
                    ElMessage({ message: '请输入 6 位验证码', type: 'warning', duration: 3 * 1000 });
                    return;
                }
                this.doLogin();
                return;
            }

            // 动态口令登录：同样不走表单校验
            if (this.activeName === 'third') {
                if (!this.form.username) {
                    ElMessage({ message: '请输入邮箱', type: 'warning', duration: 3 * 1000 });
                    return;
                }
                if (!this.form.totpcode || this.form.totpcode.length !== 6) {
                    ElMessage({ message: '请输入 6 位动态口令', type: 'warning', duration: 3 * 1000 });
                    return;
                }
                this.doLogin();
                return;
            }

            console.log('login form check');
            this.$refs.loginForm.validate(valid => {
                if (valid) {
                    this.doLogin();
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        doLogin() {
            console.log('login submit');
            let redirectSign = 'redirect=';
            let redirect = this.$route.fullPath.substring(this.$route.fullPath.indexOf(redirectSign) + redirectSign.length);
            const isCodeLogin = this.activeName === 'second';
            const isTotpLogin = this.activeName === 'third';

            this.$store
                .dispatch('user/login', {
                    username: this.form.username,
                    password: isCodeLogin || isTotpLogin ? '' : this.form.password,
                    totpcode: isTotpLogin ? this.form.totpcode : '',
                    authCode: isCodeLogin ? this.form.authCode : '',
                    uid: isCodeLogin ? this.form.uid : ''
                })
                .then(() => {
                    console.log('登录成功');
                    this.$router.push({ path: redirect || '/', params: {} });
                })
                .catch(() => {
                    console.log('登录异常');
                    // 动态口令登录失败后清空输入，便于重新输入
                    if (isTotpLogin) this.form.totpcode = '';
                });
        },
        // 动态口令输满 6 位时自动登录（v-model 已同步 form.totpcode）
        onTotpComplete() {
            if (this.activeName === 'third') {
                this.onSubmit();
            }
        },
        getAuthCodeForLogin() {
            if (!this.form.username) {
                ElMessage({ message: '请先输入邮箱', type: 'warning', duration: 3 * 1000 });
                return;
            }
            request({
                url: '/openapi/authcode/getForLogin',
                method: 'post',
                data: {
                    email: this.form.username.trim()
                }
            }).then(res => {
                if (res.code == 0) {
                    this.form.uid = res.meta.uid;
                    this.startCountdown(60);
                    ElMessage({
                        message: '验证码已发送至邮箱，请查收',
                        type: 'success',
                        duration: 5 * 1000
                    });
                }
            });
        },
        startCountdown(seconds) {
            this.stopCountdown();
            this.codeCountdown = seconds;
            this.codeTimer = setInterval(() => {
                this.codeCountdown -= 1;
                if (this.codeCountdown <= 0) this.stopCountdown();
            }, 1000);
        },
        stopCountdown() {
            if (this.codeTimer) {
                clearInterval(this.codeTimer);
                this.codeTimer = null;
            }
            this.codeCountdown = 0;
        },
        openResetPasswordDialog() {
            this.resetPasswordDialogVisible = true;
        },
        getAuthCodeForResetPassword() {
            request({
                url: '/openapi/authcode/getForResetPassword',
                method: 'post',
                data: {
                    email: this.resetPasswordForm.email,
                    token: ''
                }
            }).then(res => {
                if (res.code == 0) {
                    this.resetPasswordForm.uid = res.meta.uid;
                    ElMessage({
                        message: '验证码已发送至邮箱，请查收',
                        type: 'success',
                        duration: 5 * 1000
                    });
                }
            });
        },
        resetPassword() {
            request({
                url: '/user/resetPassword',
                method: 'post',
                data: this.resetPasswordForm
            }).then(res => {
                if (res.code == 0) {
                    ElMessage({
                        message: '重置密码成功',
                        type: 'success',
                        duration: 5 * 1000
                    });
                    this.resetPasswordDialogVisible = false;
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.login-page {
    /* 局部覆盖主色，只作用于登录页，避免影响其它页面 */
    --el-color-primary: #2f6fed;
    --el-color-primary-light-3: #6d9af2;
    --el-color-primary-light-5: #97b7f6;
    --el-color-primary-light-7: #c1d4fa;
    --el-color-primary-light-8: #d5e2fb;
    --el-color-primary-light-9: #eaf1fd;
    --el-color-primary-dark-2: #2659be;

    --login-text: #1f2d3d;
    --login-text-sub: #8a94a6;
    --login-line: #e6eaf0;

    position: relative;
    box-sizing: border-box;
    width: 100%;
    min-width: 0;
    height: 100%;
    display: flex;
    /* 内容超出时允许滚动，配合卡片 margin:auto 实现居中且不被裁切 */
    overflow-y: auto;
    padding: 72px 24px 48px;
    color: var(--login-text);
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
    background: radial-gradient(1200px 600px at 20% 0%, #ffffff 0%, rgba(255, 255, 255, 0) 60%), linear-gradient(160deg, #f6f8fc 0%, #eef2f9 100%);
}

.login-card {
    box-sizing: border-box;
    margin: auto;
    width: 100%;
    max-width: 880px;
    display: flex;
    overflow: hidden;
    background-color: #ffffff;
    border: 1px solid rgba(255, 255, 255, 0.9);
    border-radius: 18px;
    box-shadow:
        0 18px 50px -12px rgba(28, 47, 84, 0.18),
        0 4px 12px rgba(28, 47, 84, 0.04);
}

/* ---------- 品牌区 ---------- */
.login-brand {
    flex: 0 0 300px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 48px 28px;
    text-align: center;
    cursor: pointer;
    user-select: none;
    border-right: 1px solid var(--login-line);
    background: linear-gradient(165deg, #eef4ff 0%, #e6eefc 55%, #e9f0fb 100%);
}

.login-brand__logo {
    width: 148px;
    height: 148px;
    object-fit: contain;
    margin-bottom: 18px;
    filter: drop-shadow(0 8px 18px rgba(40, 70, 140, 0.14));
}

.login-brand__name {
    margin: 0;
    font-size: 26px;
    font-weight: 700;
    letter-spacing: 1px;
    color: var(--login-text);
}

.login-brand__slogan {
    margin: 8px 0 0;
    font-size: 13px;
    letter-spacing: 0.5px;
    color: var(--login-text-sub);
}

/* ---------- 表单区 ---------- */
.login-panel {
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
    flex-direction: column;
    padding: 44px 48px 36px;
}

.login-panel__head {
    margin-bottom: 22px;
}

.login-panel__title {
    margin: 0;
    font-size: 22px;
    font-weight: 600;
    letter-spacing: 0.3px;
    color: var(--login-text);
}

.login-panel__subtitle {
    margin: 8px 0 0;
    font-size: 13px;
    color: var(--login-text-sub);
}

.login-tabs :deep(.el-tabs__header) {
    margin-bottom: 22px;
}

.login-tabs :deep(.el-tabs__nav-wrap::after) {
    height: 1px;
    background-color: var(--login-line);
}

.login-tabs :deep(.el-tabs__item) {
    font-size: 14px;
    font-weight: 500;
    color: var(--login-text-sub);
}

.login-tabs :deep(.el-tabs__active-bar) {
    height: 2px;
    border-radius: 2px;
}

/* 两个页签内容高度不一致，固定最小高度避免切换时卡片跳动 */
.login-tabs :deep(.el-tabs__content) {
    min-height: 252px;
}

.login-form :deep(.el-form-item) {
    margin-bottom: 20px;
}

.login-form :deep(.el-form-item__label) {
    padding-bottom: 6px;
    font-size: 13px;
    font-weight: 500;
    line-height: 1.4;
    color: var(--login-text-sub);
}

.login-form :deep(.el-input__wrapper) {
    padding: 1px 14px;
    border-radius: 10px;
    background-color: #f7f9fc;
    box-shadow: 0 0 0 1px var(--login-line) inset;
    transition:
        box-shadow 0.2s,
        background-color 0.2s;
}

.login-form :deep(.el-input__wrapper:hover) {
    box-shadow: 0 0 0 1px #cfd8e6 inset;
}

.login-form :deep(.el-input__wrapper.is-focus) {
    background-color: #ffffff;
    box-shadow:
        0 0 0 1px var(--el-color-primary) inset,
        0 0 0 3px var(--el-color-primary-light-8);
}

.login-form :deep(.el-input__prefix) {
    color: #9aa6b8;
}

/* 验证码与「获取验证码」并排，避免按钮被挤到输入框下方 */
.login-form__row {
    display: flex;
    gap: 10px;
    width: 100%;

    :deep(.el-input) {
        flex: 1 1 auto;
        min-width: 0;
    }

    :deep(.el-button) {
        flex: 0 0 auto;
        margin-left: 0;
    }
}

.login-submit {
    width: 100%;
    height: 44px;
    margin-top: 6px;
    border-radius: 10px;
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 1px;
    box-shadow: 0 8px 18px -8px rgba(47, 111, 237, 0.65);
}

/* 动态码输入的 6 个格子改为可伸缩，适配窄屏 */
.login-form :deep(.verification-container) {
    gap: 8px;
}

.login-form :deep(.verification-input) {
    flex: 1 1 0;
    width: 100%;
    min-width: 0;
    max-width: 48px;
    height: 48px;
    margin-right: 0;
    border: 1px solid var(--login-line);
    border-radius: 10px;
    background-color: #f7f9fc;
    color: var(--login-text);
    font-size: 18px;
    transition:
        border-color 0.2s,
        box-shadow 0.2s,
        background-color 0.2s;
}

.login-form :deep(.verification-input:focus) {
    outline: none;
    border-color: var(--el-color-primary);
    background-color: #ffffff;
    box-shadow: 0 0 0 3px var(--el-color-primary-light-8);
}

.login-panel__foot {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    margin-top: 4px;
    padding-top: 18px;
    border-top: 1px solid var(--login-line);
    font-size: 13px;
}

.login-panel__foot :deep(.el-link) {
    font-size: 13px;
}

.login-panel__sep {
    width: 1px;
    height: 12px;
    background-color: var(--login-line);
}

/* ---------- 返回 ---------- */
.login-back {
    position: absolute;
    top: 20px;
    left: 24px;
    z-index: 1;
    font-size: 13px;
    color: var(--login-text-sub);
}

/* ---------- 移动端适配 ---------- */
@media (max-width: 768px) {
    .login-page {
        padding: 56px 16px 28px;
    }

    .login-card {
        max-width: 440px;
        flex-direction: column;
        border-radius: 14px;
        box-shadow: 0 10px 30px -12px rgba(28, 47, 84, 0.18);
    }

    .login-brand {
        flex: 0 0 auto;
        flex-direction: row;
        justify-content: flex-start;
        gap: 12px;
        padding: 16px 20px;
        text-align: left;
        border-right: none;
        border-bottom: 1px solid var(--login-line);
    }

    .login-brand__logo {
        width: 56px;
        height: 56px;
        margin-bottom: 0;
    }

    .login-brand__name {
        font-size: 18px;
    }

    .login-brand__slogan {
        display: none;
    }

    .login-panel {
        padding: 22px 20px 20px;
    }

    .login-panel__title {
        font-size: 19px;
    }

    .login-tabs :deep(.el-tabs__content) {
        min-height: 236px;
    }

    .login-back {
        top: 14px;
        left: 12px;
    }
}
</style>

<!-- el-dialog 会 teleport 到 body，scoped 样式无法覆盖，用独立类名限定作用域 -->
<style lang="scss">
.login-reset-dialog {
    /* 弹窗不在 .login-page 作用域内，这里重复声明主题色，保持与登录页一致 */
    --el-color-primary: #2f6fed;
    --el-color-primary-light-3: #6d9af2;
    --el-color-primary-light-5: #97b7f6;
    --el-color-primary-light-7: #c1d4fa;
    --el-color-primary-light-8: #d5e2fb;
    --el-color-primary-light-9: #eaf1fd;
    --el-color-primary-dark-2: #2659be;

    --reset-line: #e6eaf0;
    --reset-text-sub: #8a94a6;

    max-width: calc(100vw - 32px);
    border-radius: 14px;
    box-shadow: 0 18px 50px -12px rgba(28, 47, 84, 0.22);

    .el-dialog__header {
        margin-right: 0;
        padding: 22px 24px 0;
    }

    .el-dialog__headerbtn {
        top: 14px;
        right: 14px;
    }

    .el-dialog__body {
        padding: 18px 24px 4px;
    }

    .el-dialog__footer {
        padding: 0 24px 22px;
    }

    .reset-dialog__title {
        margin: 0;
        font-size: 17px;
        font-weight: 600;
        color: #1f2d3d;
    }

    .reset-dialog__subtitle {
        margin: 6px 0 0;
        font-size: 12px;
        color: var(--reset-text-sub);
    }

    .el-form-item {
        margin-bottom: 18px;
    }

    .el-form-item__label {
        padding-bottom: 6px;
        font-size: 13px;
        font-weight: 500;
        line-height: 1.4;
        color: var(--reset-text-sub);
    }

    .el-input__wrapper {
        border-radius: 10px;
        background-color: #f7f9fc;
        box-shadow: 0 0 0 1px var(--reset-line) inset;
        transition:
            box-shadow 0.2s,
            background-color 0.2s;
    }

    .el-input__wrapper:hover {
        box-shadow: 0 0 0 1px #cfd8e6 inset;
    }

    .el-input__wrapper.is-focus {
        background-color: #ffffff;
        box-shadow:
            0 0 0 1px var(--el-color-primary) inset,
            0 0 0 3px var(--el-color-primary-light-8);
    }

    /* 验证码与「获取验证码」并排，避免按钮被挤到输入框下方 */
    .reset-form__row {
        display: flex;
        gap: 10px;
        width: 100%;

        .el-input {
            flex: 1 1 auto;
            min-width: 0;
        }

        .el-button {
            flex: 0 0 auto;
            margin-left: 0;
        }
    }

    .reset-dialog__foot {
        display: flex;
        gap: 10px;

        .el-button {
            flex: 1 1 0;
            height: 40px;
            margin-left: 0;
            border-radius: 10px;
        }
    }
}
</style>
